<template>
  <v-container>
    <v-row justify="center">
      <v-card class="mx-auto" height="450" v-for="(item, index) in cardRegPat2Items" :key="index">
        <v-card-text class="mt-5">
          <p class="text-subtitle-1 primary--text font-weight-medium mb-1">
            {{ item.subtitle }}
          </p>
          <v-divider inset class="ml-0" width="900"></v-divider>
          <div class="text--primary mb-2">
            <br />
            {{ item.text }}
          </div>
        </v-card-text>
        <v-form>
          <v-row class="d-flex justify-center mx-10 mt-3">
            <v-form-base :schema="schemaFormReg2" :model="modelReg2" @input="handleEvents" />
          </v-row>
        </v-form>
        <v-card-actions>
          <v-col class="d-flex justify-end mr-10 mt-2">
            <v-btn color="secundary3" large class="text-capitalize" @click="save2">
              {{ item.regBtn }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-card>
    </v-row>
  </v-container>
</template>

<script>
import VFormBase from 'vuetify-form-base';

export default {
  components: {
    VFormBase,
  },
  name: 'VCardProPatientAReg2',
  props: [
    'cardRegPat2Items',
    'schemaFormReg2',
    'catBirthSexes',
    'modelReg2',
    'handleEvents',
    'save2',
  ],
  data() {
    return {};
  },
};
</script>
